import Request from './request'

const Device_Traffic_Statistic = {
  getDeviceTraffic (dev_id, params, callback) {
    Request.get('device-traffic-statistic/' + dev_id, params).then(callback).catch(this.bad_answer)
  },
}
export default Device_Traffic_Statistic
